module.exports = __webpack_public_path__ + "static/media/hero__news-announcements.7cd17433.jpg";